// modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// imports
import { InputGroup } from './input-group.component';
import { InputGroupItem } from './input-group-item.directive';

@NgModule({
  declarations: [
    InputGroup,
    InputGroupItem,
  ],
  exports: [
    InputGroup,
    InputGroupItem,
  ],
  imports: [
    CommonModule,
  ]
})
class InputGroupModule { }

export { InputGroup, InputGroupItem, InputGroupModule };
